import React, { FC } from "react";

const style: React.CSSProperties = {
    height: "auto",
    verticalAlign: "middle",
    width: 20
};

//
const LexV2Icon: FC<{ style?: React.CSSProperties }> = (props) => {
    return <img style={{ ...style, ...props.style }} src="/img/lexv2-logo.svg" alt="AWS Lex V2" />;
};

export { LexV2Icon };
